module.exports = __webpack_public_path__ + "img/img0.0360a6f7.jpg";